import { SIMPLE_PALETTE } from "./constants";
import { S_BAR_CHART_DETAILS } from "./signals";
import type { IStatBarChart, IStatItem } from "./types";
import { SimpleBarList } from "./SimpleBarList";
import { RankingCard } from "./RankingCard";
import { getRankingIcon, getRankingMax } from "./rankingData";

export const HBarChartCard = ({ item }: { item: IStatItem }) => {
	const icon = getRankingIcon(item);
	const data = item.data as IStatBarChart[];
	const maxItems = item.maxItems;
	const colors = SIMPLE_PALETTE;
	const hasFullReport = !!maxItems && data.length > maxItems;
	const displayData = hasFullReport ? data.slice(0, maxItems) : data;
	return <RankingCard title={item.title} icon={icon} onFullReport={hasFullReport ? () => S_BAR_CHART_DETAILS.invoke({ title: item.title, data, colors, icon }) : undefined}>
		<SimpleBarList data={displayData} colors={colors} maxVal={getRankingMax(data)} icon={icon} />
	</RankingCard>;
};
